import './styles/main.scss'
import SiteSlider from './scripts/SiteSlider'
import SliderHeader from './scripts/SliderHeader'
import SliderJackpot from './scripts/SliderJackpot'
import SliderReview from './scripts/SliderReview'
import BlogPostAll from './scripts/BlogPostAll'
import MyNotes from './scripts/MyNotes'
import React from 'react'
import ReactDOM from 'react-dom'

const perslider = new SiteSlider()
const reviewNot = new MyNotes()
if(document.querySelector("#slider-destop")){
    ReactDOM.render(<SliderHeader />, document.querySelector("#slider-header"))
}

if(document.querySelector("#slider-jackpot")){
    ReactDOM.render(<SliderJackpot />, document.querySelector("#slider-jackpot"))
}

if(document.querySelector("#slider-review")){
    ReactDOM.render(<SliderReview />, document.querySelector("#slider-review"))
}

if(document.querySelector("#gameonline-blog-posts")){
    ReactDOM.render(<BlogPostAll />, document.querySelector("#gameonline-blog-posts"))
}
